/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Modal,
  Row,
  Table
} from 'react-bootstrap'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import BreadCrumb from '../../../components/Label/Breadcrumb'
import api from '../../../config/AxiosInstance'
import {
  capitalizeFirstLetter,
  convertDateWithTime
} from '../../../helpers/constants'
import Loading from '../../../components/atoms/Loading'
import toast, { Toaster } from 'react-hot-toast'
import { Plus, ChevronDown, ChevronUp, Copy } from 'lucide-react'
import { BadgeStatusPrLists } from '../../../components/atoms/StatusLabel'
import ModalStockAdjustment from '../../../components/modal/stockAdjustment/ModalStockAdjustment'

const cardStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const labelDetailStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#999',
  textTransform: 'uppercase',
  marginBottom: '0.25rem',
  letterSpacing: '0.5px'
}

const StyledDetailField = ({ label, value, col = 3, children, address }) => {
  return (
    <Form.Group className={`mb-3 col-12 col-md-${col}`}>
      <Form.Label style={labelDetailStyle}>{label}</Form.Label>
      <div
        className="px-0"
        style={{
          fontSize: '0.9rem',
          fontWeight: '500',
          color: '#212529',
          minHeight: '24px'
        }}
      >
        {address ? (
          <div dangerouslySetInnerHTML={{ __html: value }} />
        ) : children ? (
          children
        ) : (
          value
        )}
      </div>
    </Form.Group>
  )
}

const WorkOrderRepackDetail = () => {
  const { code } = useParams()
  const navigate = useNavigate()
  const { state } = useLocation()
  const [data, setData] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [loadingSendToErp, setLoadingSendToErp] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [seriesNumbers, setSeriesNumbers] = useState([])
  const [seriesNumber, setSeriesNumber] = useState(null)
  const [progressCollapse, setProgressCollapse] = useState(true)

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text)
    toast.success('Copied to clipboard!', {
      position: 'top-right',
      style: {
        fontSize: '14px',
        fontWeight: '600'
      }
    })
  }

  const renderType = (type) => {
    let text = '-'
    switch (type) {
      case 'repack':
        text = 'Repack'
        break
      case 'extend':
        text = 'Extend'
        break
      case 'repack_extend':
        text = 'Repack and Extend'
        break
      default:
        break
    }
    return text
  }
  const columnTarget = [
    {
      key: 'sequence',
      label: 'No'
    },
    {
      key: 'item',
      label: 'Item Code - Name',
      component: (value) => `${value?.item_code || ''} - ${value?.item || ''}`
    },
    {
      key: 'batch',
      label: 'Batch',
      className: 'text-end',
      component: (value) => value?.batch || '-'
    },
    {
      key: 'expired',
      label: 'Expired',
      className: 'text-end',
      component: (value) =>
        value?.expired ? convertDateWithTime(value?.expired, 'DD-MM-YYYY') : '-'
    },
    {
      key: 'qty_pack',
      label: 'Qty@Pack',
      className: 'text-end',
      component: (value) => value?.qty_pack || '-'
    },
    {
      key: 'total_pack',
      label: 'Qty Kemasan',
      className: 'text-end',
      component: (value) =>
        value?.total_pack ? `${value?.total_pack} ${value?.uom_pack}` : '-'
    },
    {
      key: 'total_qty',
      label: 'Base UOM Qty',
      className: 'text-end',
      component: (value) =>
        value?.total_qty ? `${value?.total_qty} ${value?.uom || ''}` : '-'
    }
  ]
  const columnSource = [
    {
      key: 'sequence',
      label: 'No'
    },
    {
      key: 'item',
      label: 'Item Code - Name',
      component: (value) => `${value?.item_code || ''} - ${value?.item || ''}`
    },
    {
      key: 'Batch',
      label: 'Batch',
      className: 'text-end',
      component: (value) => value?.batch || '-'
    },
    {
      key: 'total_pack',
      label: 'Qty Kemasan',
      className: 'text-end',
      component: (value) =>
        value?.total_pack ? `${value?.total_pack} ${value?.uom_pack}` : '-'
    },
    {
      key: 'total_qty',
      label: 'Base UOM Qty',
      className: 'text-end',
      component: (value) =>
        value?.total_qty ? `${value?.total_qty} ${value?.uom}` : '-'
    }
  ]

  const columnRelatedWo = [
    {
      key: 'sequence',
      label: 'No'
    },
    {
      key: 'code',
      label: 'Code',
      component: (value) => (
        <div className="d-flex align-items-center gap-2 text-primary fw-semibold">
          <span
            className="cursor-pointer"
            onClick={() =>
              window.open(
                `/workorder/repack/detail/${encodeURIComponent(value?.code)}`,
                '_blank'
              )
            }
            style={{ textDecoration: 'underline' }}
          >
            {value?.code}
          </span>
          <Copy
            size={14}
            className="text-muted cursor-pointer"
            style={{
              cursor: 'pointer',
              opacity: 0.5,
              transition: 'opacity 0.2s'
            }}
            onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
            onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.5)}
            onClick={() => handleCopy(value?.code)}
            title="Copy Code"
          />
        </div>
      )
    },
    {
      key: 'type',
      label: 'Type',
      component: (value) => renderType(value?.type)
    },
    {
      key: 'status',
      label: 'Status',
      className: 'text-center',
      component: (value) => (
        <BadgeStatusPrLists text={value?.status?.replaceAll('_', ' ')} />
      )
    },
    {
      key: 'target',
      label: 'Target',
      component: (value) => value?.target || '-'
    },
    {
      key: 'target_batch',
      label: 'Target Batch',
      component: (value) => value?.target_batch || '-'
    },
    {
      key: 'target_qty',
      label: 'Target Qty',
      className: 'text-end',
      component: (value) => value?.target_qty || '-'
    }
  ]

  const fetchDetailWorkOrder = async () => {
    try {
      setIsLoading(true)
      const params = {
        wo: code || '',
        suggest: 0
      }
      const res = await api.get('/outbound/work-order-repack/detail', {
        params
      })
      const { data } = res.data
      setData(data)
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      navigate('/workorder/repack', {
        replace: true,
        state: state
      })
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setIsLoading(false)
    }
  }

  const handleSendToErp = async () => {
    try {
      setLoadingSendToErp(true)
      const res = await api.post(
        `outbound/work-order-repack/${data?.id}/send-erp`
      )
      const { data: dataResponse } = res
      if (dataResponse) {
        toast.success('Send to erp success', {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
        fetchDetailWorkOrder()
      }
    } catch (error) {
      setLoadingSendToErp(false)
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }
  const handleModal = () => {
    setIsOpen(!isOpen)
    if (!isOpen) {
      setSeriesNumber(null)
    }
  }
  const fetchSeriesNumber = async () => {
    try {
      const res = await api.get(`/outbound/work-order-repack/series`, {
        params: {
          wo: code
        }
      })
      const { data } = res.data
      setSeriesNumbers(data)
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }
  useEffect(() => {
    fetchDetailWorkOrder()
    fetchSeriesNumber()
  }, [])

  if (isLoading) {
    return <Loading />
  }

  return (
    <>
      <Toaster />
      <Container>
        <Row className="mb-3">
          <Col md={4}>
            <BreadCrumb
              label={code}
              link="/workorder/repack"
              back="REPACK LIST"
              subLabel="DETAIL"
              status={data?.status}
              type={'WorkOrderStatus'}
              stateValue={state}
            />
          </Col>
        </Row>

        <Card style={cardStyle}>
          <Row>
            <StyledDetailField
              label="Request Time"
              value={
                data?.request_time
                  ? convertDateWithTime(data?.request_time, 'DD-MM-YYYY, HH:mm')
                  : '-'
              }
              col={3}
            />
            <StyledDetailField
              label="Type"
              value={renderType(data?.type)}
              col={3}
            />
            <StyledDetailField
              label="ERP WO NO"
              value={data?.erp_wo || '-'}
              col={3}
            />
            <StyledDetailField
              label="WAREHOUSE"
              value={data?.warehouse || '-'}
              col={3}
            />
          </Row>
        </Card>

        <Card style={cardStyle}>
          <h5 className="fw-bold text-uppercase mb-3" style={{ color: '#333' }}>
            TARGET
          </h5>
          <Table responsive hover style={{ fontSize: '13px' }}>
            <thead style={{ backgroundColor: '#f8f9fa' }}>
              <tr>
                {columnTarget.map((column) => (
                  <th
                    className={`align-middle p-2 ${column.className}`}
                    key={column.key}
                    style={tableHeaderStyle}
                  >
                    <span>{column.label}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data?.target?.length === 0 && (
                <tr>
                  <td colSpan={columnTarget.length} className="p-3">
                    <div className="d-flex justify-content-center">
                      <span className="text-secondary">No data available</span>
                    </div>
                  </td>
                </tr>
              )}
              {data?.target?.length > 0 &&
                data?.target?.map((item, index) => (
                  <tr key={`${item.id}-${index}`}>
                    {columnTarget.map((column) => (
                      <td
                        key={column.key}
                        className={`align-middle p-2 ${column.className}`}
                      >
                        {column.key === 'sequence' && index + 1}
                        {column.component && column.component(item)}
                        {!column.component && item[column.key]}
                      </td>
                    ))}
                  </tr>
                ))}
            </tbody>
          </Table>
        </Card>

        <Card style={cardStyle}>
          <h5 className="fw-bold text-uppercase mb-3" style={{ color: '#333' }}>
            SOURCE
          </h5>
          <Table responsive hover style={{ fontSize: '13px' }}>
            <thead style={{ backgroundColor: '#f8f9fa' }}>
              <tr>
                {columnSource.map((column) => (
                  <th
                    className={`align-middle p-2 ${column.className}`}
                    key={column.key}
                    style={tableHeaderStyle}
                  >
                    <span>{column.label}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data?.sources?.length === 0 && (
                <tr>
                  <td colSpan={columnSource.length} className="p-3">
                    <div className="d-flex justify-content-center">
                      <span className="text-secondary">No data available</span>
                    </div>
                  </td>
                </tr>
              )}
              {data?.sources?.length > 0 &&
                data?.sources?.map((item, index) => (
                  <tr key={`${item.id}-${index}`}>
                    {columnSource.map((column) => (
                      <td
                        key={column.key}
                        className={`align-middle p-2 ${column.className}`}
                      >
                        {column.key === 'sequence' && index + 1}
                        {column.component && column.component(item)}
                        {!column.component && item[column.key]}
                      </td>
                    ))}
                  </tr>
                ))}
            </tbody>
          </Table>
        </Card>

        {data?.related_wo && data?.related_wo?.length > 0 && (
          <Card style={cardStyle}>
            <h5
              className="fw-bold text-uppercase mb-3"
              style={{ color: '#333' }}
            >
              RELATED WO
            </h5>
            <Table responsive hover style={{ fontSize: '13px' }}>
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  {columnRelatedWo.map((column) => (
                    <th
                      className={`align-middle p-2 ${column.className || ''}`}
                      key={column.key}
                      style={tableHeaderStyle}
                    >
                      <span>{column.label}</span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data?.related_wo?.map((item, index) => (
                  <tr key={`${item.id}-${index}`}>
                    {columnRelatedWo.map((column) => (
                      <td
                        key={column.key}
                        className={`align-middle p-2 ${column.className || ''}`}
                      >
                        {column.key === 'sequence' && index + 1}
                        {column.component && column.component(item)}
                        {!column.component && item[column.key]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card>
        )}

        <Card style={cardStyle}>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5
              className="fw-bold text-uppercase mb-0"
              style={{ color: '#333' }}
            >
              JOB STATUS
            </h5>
            {!data?.job && (
              <Button
                variant="transparent"
                className="btn-primary-orange d-flex align-items-center gap-2"
                style={{ height: '33px' }}
                onClick={handleModal}
              >
                <Plus size={14} />
                <span>Job Manufacture</span>
              </Button>
            )}
          </div>

          {data?.job && (
            <Table responsive hover style={{ fontSize: '13px' }}>
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  <th
                    className="align-middle p-2"
                    key="th-job-sequence"
                    style={tableHeaderStyle}
                  >
                    <span>No</span>
                  </th>
                  <th
                    className="align-middle p-2"
                    key="th-job-ticket"
                    style={tableHeaderStyle}
                  >
                    <span>Ticket</span>
                  </th>
                  <th
                    className="align-middle p-2 text-end"
                    key="th-job-status"
                    style={tableHeaderStyle}
                  >
                    <span>Status</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {typeof data?.job === 'object' && (
                  <tr key={data?.job?.code}>
                    <td className="align-middle p-2">1</td>
                    <td className="align-middle p-2">
                      <Link
                        to={`/workorder/job-status/detail/${data?.job?.id}`}
                        replace={true}
                      >
                        {data?.job?.code}
                      </Link>
                    </td>
                    <td className="align-middle p-2 text-end">
                      {
                        <BadgeStatusPrLists
                          text={data?.job?.status?.replaceAll('_', ' ')}
                        />
                      }
                    </td>
                  </tr>
                )}
                {Array.isArray(data?.job) &&
                  data?.job.map((jobItem, idx) => (
                    <tr key={jobItem.code || idx}>
                      <td className="align-middle p-2">{idx + 1}</td>
                      <td className="align-middle p-2">
                        <Link
                          to={`/workorder/job-status/detail/${jobItem.id}`}
                          replace={true}
                        >
                          {jobItem.code}
                        </Link>
                      </td>
                      <td className="align-middle p-2">{jobItem.status}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          )}
        </Card>

        <Card style={cardStyle}>
          <div className="d-flex gap-1 justify-content-between">
            <h5
              className="fw-bold text-uppercase mb-3"
              style={{ color: '#333' }}
            >
              PROGRESS DETAIL
            </h5>
            <div className="d-flex flex-column justify-content-center align-items-center">
              <Button
                variant="transparent"
                className="p-0"
                style={{ marginTop: '-0.2rem' }}
              >
                {progressCollapse ? (
                  <ChevronUp
                    size={16}
                    className="ms-1 text-muted"
                    onClick={() => setProgressCollapse(!progressCollapse)}
                    style={{ cursor: 'pointer' }}
                  />
                ) : (
                  <ChevronDown
                    size={16}
                    className="ms-1 text-muted"
                    onClick={() => setProgressCollapse(!progressCollapse)}
                    style={{ cursor: 'pointer' }}
                  />
                )}
              </Button>
            </div>
          </div>
          <Collapse in={progressCollapse}>
            <ul className="list-unstyled mb-0">
              {data?.progress?.length > 0 &&
                data?.progress?.map((item) => (
                  <li key={item.id} className="mb-2">
                    <div className="d-flex flex-row gap-3 progress-detail align-items-center">
                      <div className="circle-progress-detail"></div>
                      <p
                        className="mb-0 text-muted"
                        style={{ fontSize: '0.9rem', minWidth: '100px' }}
                      >
                        {item.datetime ? item.datetime : '-'}
                      </p>
                      <div
                        className="d-flex flex-column justify-content-center"
                        style={{ height: '20px' }}
                      >
                        <div className="d-flex flex-row gap-3 align-items-center">
                          <div className="circle-small-progress-detail"></div>
                          <span
                            style={{ fontSize: '13px' }}
                            className="fw-bold text-dark"
                          >
                            {item.description}
                          </span>
                        </div>
                      </div>
                    </div>
                    <ul
                      className="list-unstyled"
                      style={{
                        marginLeft: '3.5rem',
                        marginTop: '0px',
                        marginBottom: '8px'
                      }}
                    >
                      {item?.detail?.length > 0 &&
                        item?.detail?.map((detail, index) => (
                          <span
                            key={index}
                            style={{
                              color: detail.color,
                              fontSize: '0.85rem'
                            }}
                          >
                            {detail.description}{' '}
                            {index < item.detail.length - 1 ? ', ' : ''}
                          </span>
                        ))}
                    </ul>
                  </li>
                ))}
            </ul>
          </Collapse>
        </Card>

        {data?.job &&
          typeof data?.job === 'object' &&
          (data?.status === 'done' || data?.status === 'confirmed') &&
          !data?.send_erp && (
            <Row className="mb-3">
              <Col md={12}>
                <Card style={cardStyle}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                      <p className="mb-0 text-danger fw-bold">
                        Make Sure to Send to ERP After Manufacturing Done
                      </p>
                    </div>
                    <Button
                      variant="transparent"
                      className={`${
                        loadingSendToErp || data?.status === 'confirmed'
                          ? 'btn-secondary opacity-25'
                          : 'btn-primary-orange'
                      } `}
                      style={{ height: '33px' }}
                      disabled={
                        loadingSendToErp || data?.status === 'confirmed'
                      }
                      onClick={handleSendToErp}
                    >
                      Send to ERP
                    </Button>
                  </div>
                </Card>
              </Col>
            </Row>
          )}
        {data?.job &&
          Array.isArray(data?.job) &&
          data?.job?.every((job) => job?.status === 'done') &&
          data?.status !== 'done' && (
            <Row className="mb-3">
              <Col md={12}>
                <Card style={cardStyle}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                      <p className="mb-0 text-danger fw-bold">
                        Make Sure to Send to ERP After Manufacturing Done
                      </p>
                    </div>
                    <Button
                      variant="transparent"
                      className="btn-primary-orange"
                      style={{ height: '33px' }}
                    >
                      Send to ERP
                    </Button>
                  </div>
                </Card>
              </Col>
            </Row>
          )}

        <Card style={cardStyle}>
          <Row>
            <StyledDetailField
              label="created by"
              value={
                data?.created_by ? capitalizeFirstLetter(data?.created_by) : '-'
              }
              col={3}
            />
            <StyledDetailField
              label="created at"
              value={
                data?.created_at && data?.created_at !== '-'
                  ? convertDateWithTime(data?.created_at, 'DD-MM-YYYY, HH:mm')
                  : '-'
              }
              col={3}
            />
            <StyledDetailField
              label="last updated by"
              value={
                data?.updated_by ? capitalizeFirstLetter(data?.updated_by) : '-'
              }
              col={3}
            />
            <StyledDetailField
              label="last updated at"
              value={
                data?.updated_at
                  ? convertDateWithTime(data?.updated_at, 'DD-MM-YYYY, HH:mm')
                  : '-'
              }
              col={3}
            />
          </Row>
        </Card>

        <ModalStockAdjustment
          show={isOpen}
          onHide={handleModal}
          title="Create Job Manufacture"
          size="md"
          backdrop="static"
        >
          <Modal.Body
            className="my-2"
            style={{ height: '140px', overflowY: 'auto' }}
          >
            <div className="my-2">
              <Col md={12}>
                <Form.Label
                  className="text-muted text-uppercase fw-bold"
                  htmlFor="series-number"
                >
                  Series Number
                </Form.Label>
                <Form.Select
                  id="series-number"
                  aria-label="series-number"
                  onChange={(e) => {
                    setSeriesNumber(e.target.value)
                  }}
                >
                  <option value="">Select Seris Number</option>
                  {seriesNumbers?.map((item) => (
                    <option value={item.name}>{item.name}</option>
                  ))}
                </Form.Select>
              </Col>
            </div>
            <Modal.Footer className="mt-3">
              <div>
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <div className="d-flex gap-2">
                    <Button variant="transparent" onClick={handleModal}>
                      Close
                    </Button>
                    <Button
                      variant="transparent"
                      className={
                        !seriesNumber
                          ? 'btn-secondary opacity-25'
                          : 'btn-primary-orange'
                      }
                      disabled={!seriesNumber}
                      onClick={() => {
                        navigate(`/workorder/repack/create/${code}`, {
                          state: {
                            ...state,
                            seriesNumber: seriesNumber
                          }
                        })
                      }}
                    >
                      Create
                    </Button>
                  </div>
                </div>
              </div>
            </Modal.Footer>
          </Modal.Body>
        </ModalStockAdjustment>
      </Container>
    </>
  )
}

export default WorkOrderRepackDetail
